import { styled } from '@openeducation/oe-rn-themes';
import { rgba } from 'polished';
import React from 'react';
import { View } from 'react-native';

import { OEText } from '../../atoms/oe-text/oe-text';
import { flex } from '../../style-utils';

export interface EllipseIconProps {
  color?: string;
  iconSize: number;
  children?: React.ReactNode;
}

export const EllipseIcon: React.FC<EllipseIconProps> = ({
  color,
  iconSize = 32,
  children,
}) => {
  return (
    <View
      style={[flex('flex-row', 'justify-content-center', 'align-items-center')]}
    >
      <Circle color={color} iconSize={iconSize}>
        <StyledText color={color} iconSize={iconSize}>
          {children}
        </StyledText>
      </Circle>
    </View>
  );
};

const StyledText = styled(OEText)<{ iconSize: number; color?: string }>`
  font-size: ${({ iconSize }) => `${iconSize * 0.625}px`};
  color: ${({ theme, color }) => (color ? color : theme.color.primary)};
`;

const Circle = styled.View<{ iconSize: number; color?: string }>`
  width: ${({ iconSize }) => `${iconSize * 2.5}px`};
  height: ${({ iconSize }) => `${iconSize * 2.5}px`};
  border-radius: ${({ iconSize }) => `${(iconSize * 2.5) / 2}px`};
  margin-horizontal: 10px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, color }) =>
    rgba(color ? color : theme.color.primary, 0.15)};
`;
